import { PartnerUserJSON } from '@jurnee/common/src/entities/PartnerUser';
import { PartnerJwt, parseJwt } from '@jurnee/common/src/utils/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from 'api/user';
import { RootState } from '..';

export const getUser = createAsyncThunk<PartnerUserJSON | null, void, { state: RootState }>('FETCH_USER', async (_, thunkAPI) => {
  try {
    const { auth } = thunkAPI.getState();

    if (!auth.token) {
      return null;
    }

    const jwt = parseJwt<PartnerJwt>(auth.token);

    if (jwt.type === 'PARTNER_ACCESS_TOKEN') {
      return null;
    }

    return await api.getUser(jwt.partnerUserId);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    return thunkAPI.rejectWithValue({ message });
  }
});